import React from "react";
import GalleryVideoDetailsPlayer from "../../pages/events/ViewPhoto/GalleryVideoDetailsPlayer";

const VideoPlayer = ({ activeItemIndex, dataSlider, videoShareDetails }) => (
  <GalleryVideoDetailsPlayer
    activeItemIndex={activeItemIndex}
    dataSlider={dataSlider}
    directory="video"
    fileKey="event_video"
    initialDetails={videoShareDetails}
    title="Video details"
  />
);

export default VideoPlayer;
